var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "main" },
    [
      _c("v-page-header", {
        attrs: { title: _vm.$t("home.quicklinks2.manage_users") },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container" }, [
        _c("div", { staticClass: "grid-x" }, [
          _c(
            "div",
            {
              staticClass:
                "cell medium-9 medium-offset-1 large-11 large-offset-0",
            },
            [
              _c(
                "div",
                { staticClass: "wrapper" },
                [
                  _c("v-action-buttons", {
                    attrs: { items: _vm.getActionButtons },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "box" },
                    [
                      _c(
                        "form",
                        {
                          staticClass: "filter filter--search",
                          attrs: {
                            action: "",
                            method: "POST",
                            novalidation: "",
                          },
                          on: { submit: _vm.onChangeAccountsTableFilter },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "form-group form-group--search" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.accountsTableFilter.search,
                                    expression: "accountsTableFilter.search",
                                  },
                                ],
                                staticClass:
                                  "form-control form-control--small form-control--search",
                                attrs: {
                                  type: "text",
                                  name: "search",
                                  placeholder: _vm.$t("search"),
                                },
                                domProps: {
                                  value: _vm.accountsTableFilter.search,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.accountsTableFilter,
                                      "search",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "button",
                                  attrs: {
                                    role: "button",
                                    type: "submit",
                                    title: _vm.$t("search"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("search")) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-table", {
                        attrs: {
                          isLoading: _vm.accountsTableLoading,
                          columns: _vm.accountsTableColumns,
                          items: _vm.accountsTableItems,
                          showShowAll: false,
                          showShowDeactivatedOnly: true,
                          showDeactivatedOnly:
                            _vm.accountsTableFilter.show_deactivated_only,
                        },
                        on: {
                          onChangeShowDeactivatedOnly:
                            _vm.onChangeShowDeactivatedOnlyAccountsTableFilter,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "name",
                            fn: function ({ row }) {
                              return [
                                _c("span", { staticClass: "table-label" }, [
                                  _vm._v(_vm._s(row.profile.lastname)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "table-description" },
                                  [_vm._v(_vm._s(row.profile.firstname))]
                                ),
                              ]
                            },
                          },
                          {
                            key: "email",
                            fn: function ({ row }) {
                              return [
                                _c("span", { staticClass: "table-label" }, [
                                  _vm._v(
                                    _vm._s(row.profile.communication.email)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "table-description" },
                                  [_vm._v(_vm._s(_vm.$t("form.account.email")))]
                                ),
                              ]
                            },
                          },
                          {
                            key: "shouldReceiveProjectUpdateNotification",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { display: "inline-block" } },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "table-label" },
                                      [
                                        _c("v-select-active", {
                                          staticStyle: {
                                            "--u-maxwidth": "100px",
                                          },
                                          attrs: {
                                            className:
                                              "form-control--extra--small u-maxwidth",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onChangeReceiveProjectUpdateNotifications(
                                                $event,
                                                row.id
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              row.shouldReceiveProjectUpdateNotification,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                row,
                                                "shouldReceiveProjectUpdateNotification",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "row.shouldReceiveProjectUpdateNotification",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "details",
                                      {
                                        staticClass:
                                          "o-details o-details--text-sm u-extra-xxsmall-margin--top",
                                      },
                                      [
                                        _c("summary", [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "account.project.email_notification_on_update_title"
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "account.project.email_notification_on_update_description"
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "user_type",
                            fn: function ({ row }) {
                              return [
                                _c("span", { staticClass: "table-label" }, [
                                  _vm._v(_vm._s(row.user_type.name)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "table-description" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("form.account.permissions"))
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "status",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "table-label" },
                                  [
                                    _c("v-select-active", {
                                      attrs: {
                                        className: "form-control--small",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.onChangeStatus(
                                            $event,
                                            row.id
                                          )
                                        },
                                      },
                                      model: {
                                        value: row.active,
                                        callback: function ($$v) {
                                          _vm.$set(row, "active", $$v)
                                        },
                                        expression: "row.active",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "table-description" },
                                  [_vm._v(_vm._s(_vm.$t("active")))]
                                ),
                              ]
                            },
                          },
                          {
                            key: "update",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "button button--action button--action--edit button--small",
                                    attrs: {
                                      to: {
                                        name: "account-update",
                                        params: { account: row.id },
                                      },
                                      title: _vm.$t("update"),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("update")) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("v-pagination", {
                        attrs: {
                          currentPage: _vm.accountsTableCurrentPage,
                          itemsPerPage: _vm.accountsTableItemsPerPage,
                          items: _vm.accountsTableItemsCount,
                        },
                        on: { pageClicked: _vm.onChangeAccountsTablePage },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }